var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AskOkMessage, AutoScaleChildrenFacet, convertToNumber3, EnterRoomMessage, LayouterParameters, LayoutFacet, LoadRoomMessage, RequestRoomLoadedStateMessage, RoomLoadedState, RoomLoadedStateMessage, UnloadRoomMessage, } from "flavr-common";
import { createModelInstance, resolveUid } from "../model/Utils";
import { scriptService } from "../services/ScriptService";
import { ChangeRoomVisibilityMessage } from "../../../messages/rendering/MeshMessages";
import { useExternalMessages, modelPool } from "@modules/model";
class WorldLayouterParameters extends LayouterParameters {
    constructor(worldId) {
        super();
        this.worldId = worldId;
    }
}
WorldLayouterParameters.layouterId = "world";
export class ScriptRoom {
    static create(params) {
        var _a;
        if (scriptService.context === undefined)
            throw new Error("This should not happen");
        // Determine the parent uid
        let parentUID;
        if (params.parent !== undefined) {
            parentUID = resolveUid(params.parent);
        }
        else if (scriptService.context.hasCurrentRoom()) {
            parentUID = (_a = scriptService.context.currentRoom) === null || _a === void 0 ? void 0 : _a.roomUID;
        }
        if (parentUID === undefined)
            throw new TypeError("parent is invalid");
        const parentModel = modelPool.getModelOrThrow(parentUID);
        if (params.relativeId === undefined)
            throw new TypeError("relativeId is undefined");
        if (typeof params.worldId !== "string")
            throw new TypeError("worldId is not a string");
        const roomName = params.relativeId;
        let room = parentModel.getChild(roomName);
        const messages = [];
        const props = useExternalMessages(messages);
        if (room === undefined) {
            room = modelPool.createRoomModel(roomName, parentModel, props);
            room.setTransformComponents([0, 0, 0], [1, 0, 0, 0], [1, 1, 1], props);
        }
        room.setFacet(new LayoutFacet(new WorldLayouterParameters(params.worldId)), props);
        room.setFacet(new AutoScaleChildrenFacet({ margin: 0.2 }), props);
        scriptService.context.connection.sendMultiple(messages);
        return createModelInstance(room.getUID());
    }
    static load(room_1) {
        return __awaiter(this, arguments, void 0, function* (room, params = {}) {
            if (!scriptService.context)
                return false;
            try {
                const roomUid = resolveUid(room);
                scriptService.context.flushMessages();
                scriptService.context.connection.send(new ChangeRoomVisibilityMessage(roomUid, false));
                yield scriptService.context.connection.askByMessageType(new LoadRoomMessage(roomUid, params.controllerUid, params.immediately), AskOkMessage);
                return true;
            }
            catch (error) {
                console.error(error);
            }
            return false;
        });
    }
    static unload(room, params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!scriptService.context)
                return false;
            try {
                const roomUid = resolveUid(room);
                scriptService.context.flushMessages();
                yield scriptService.context.connection.askByMessageType(new UnloadRoomMessage(roomUid, params.controllerUid, params.immediately), AskOkMessage);
                return true;
            }
            catch (error) {
                console.error(error);
            }
            return false;
        });
    }
    static enter(room_1) {
        return __awaiter(this, arguments, void 0, function* (room, options = {}) {
            // ToDo: The first part can be replaced by calling this.getState(room)
            if (!scriptService.context)
                return false;
            const connection = scriptService.context.connection;
            const roomUid = resolveUid(room);
            scriptService.context.flushMessages();
            const roomResponse = yield connection.askByMessageType(new RequestRoomLoadedStateMessage(roomUid), RoomLoadedStateMessage);
            switch (roomResponse.state) {
                case RoomLoadedState.Loaded:
                    const position = options.entryPoint ? convertToNumber3(options.entryPoint) : undefined;
                    connection.send(new EnterRoomMessage(roomUid, {
                        position,
                        positionIsInRoomCoordinates: !!options.entryPoint,
                        flying: options.flying,
                        returnPoint: options.returnPoint
                    }));
                    return true;
                case RoomLoadedState.NotLoaded:
                    void this.load(roomUid, {
                        controllerUid: options.controllerUid
                    });
                    break;
            }
            return false;
        });
    }
    static getState(room) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!scriptService.context)
                    return -1;
                const connection = scriptService.context.connection;
                const roomUid = resolveUid(room);
                scriptService.context.flushMessages();
                const roomResponse = yield connection.askByMessageType(new RequestRoomLoadedStateMessage(roomUid), RoomLoadedStateMessage);
                return roomResponse.state;
            }
            catch (error) {
                console.error("error:", error);
                return -1;
            }
        });
    }
}
